import { COMPANION_QUICK_ACTIONS } from "@/components/daily/companionIntent";
import { COMPANION_QUICK_ACTIONS_V2 } from "@/components/daily/companionQuickActionsV2";

COMPANION_QUICK_ACTIONS.splice(
  0,
  COMPANION_QUICK_ACTIONS.length,
  ...COMPANION_QUICK_ACTIONS_V2,
);
